import styled from 'styled-components';

export const Container = styled.main`
  width: 100%;
  max-width: 1200px;
  min-height: 100dvh;
  margin: 40px auto;
  padding: 20px;
`;

export const Header = styled.header`
  text-align: center;
  margin-bottom: 40px;
  margin-top: 60px;

  h1 {
    font-size: 2.5rem;
    color: ${(props) => props.theme.colors.text};
    margin-bottom: 8px;
  }

  p {
    font-size: 1.1rem;
    color: ${(props) => props.theme.colors.text_light};
  }
`;

export const Loading = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
  font-size: 1.2rem;
  color: ${(props) => props.theme.colors.text_light};
`;

export const PostGrid = styled.div`
  display: grid;
  /* Cria colunas que têm no mínimo 450px de largura.
    Se não couber, ele quebra a linha automaticamente.
    '1fr' faz com que ocupem todo o espaço disponível.
  */
  grid-template-columns: repeat(auto-fit, minmax(550px, 1fr));
  gap: 32px; /* Espaçamento entre os posts */
`;

export const PostWrapper = styled.div`
  /* O wrapper garante que o embed do LinkedIn tenha um container
    com um fundo e sombra, o que fica mais agradável visualmente
    enquanto o conteúdo do post está carregando.
  */
  display: flex;
  justify-content: center;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  min-height: 200px; /* Altura mínima para o placeholder de loading */
`;
